import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import appConfig from 'application-config';

import { IS_DEVEL, FAKE_TURNSTILE_TOKEN } from 'client/constants';

import * as css from './StatusBar.scss';

const TURNSTILE_CONTAINER_ID = 'turnstile-container';

const template = (count, maxCount, nameHE) =>
	count < maxCount ? `בחרת  ${count}/${maxCount} ${nameHE}` : `בחרת  ${count} ${nameHE}`;

const StatusBar = props => {
	const { minCount, maxCount, count, nameHE } = props;
	const [token, setToken] = React.useState('');
	const progressTransform = `translateX(${100 - (count / maxCount) * 100}%)`;
	const stylesMain = {
		zIndex: 8,
	};

	const onFinishBtnClick = () => {
		props.onFinishClick(token);
	};

	React.useEffect(() => {
		if (IS_DEVEL) {
			setToken(FAKE_TURNSTILE_TOKEN);
		} else {
			const turnstileContainer = document.getElementById(TURNSTILE_CONTAINER_ID);

			if (turnstileContainer && !turnstileContainer.hasChildNodes() && window.turnstile) {
				window.turnstile.render(`#${TURNSTILE_CONTAINER_ID}`, {
					sitekey: appConfig.domains.turnstile.siteKey,
					action: 'submission',
					callback: t => {
						setToken(t);
					},
				});
			}
		}
	}, []);

	return (
		<div className={classnames(css.bar, { [css.in]: count > 0 })} style={stylesMain}>
			<div id={TURNSTILE_CONTAINER_ID} />
			<div className={css.inner}>
				<div className={css.container}>
					<div className={css.barContent}>
						<div className={css.barInfo}>
							<div className={css.barInfoText}>
								<p>{template(count, maxCount, nameHE)}</p>
								{maxCount > 1 && <p>{`עליך לבחור לפחות ${minCount} ${nameHE}`}</p>}
							</div>
							<div className={css.barProgress}>
								<div
									className={css.line}
									style={{
										WebkitTransform: progressTransform,
										transform: progressTransform,
									}}
								/>
							</div>
						</div>
						<div className={css.barActions}>
							<div
								type="button"
								className={classnames(css.btn, (count < minCount || !token) && css.disabled)}
								onClick={onFinishBtnClick}
							>
								סיימתי
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

StatusBar.propTypes = {
	count: PropTypes.number.isRequired,
	onFinishClick: PropTypes.func.isRequired,
	minCount: PropTypes.number.isRequired,
	maxCount: PropTypes.number.isRequired,
	nameHE: PropTypes.string.isRequired,
};

export default StatusBar;
